import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { triggerGTAGInternalNavEvent } from '@/utils/analyticTracks';

import paths from '../../../../AppRouter/paths';
import { PlayersContext } from '../../../../context/PlayersContext';
import SidebarButton from '../../../SidebarButton';
import { SidebarButtonProps } from '../../../SidebarButton/types';
import Game from '../../icons/Game';
import Helmet from '../../icons/Helmet';
import Home from '../../icons/Home';
import HowToPlay from '../../icons/HowToPlay';
import Leaderboard from '../../icons/Leaderboard';
import Social from '../../icons/Social';
import HelpComponents from '../HelpComponents/HelpComponents';
import SocialLink from '../SocialLink';

import { NavigationWrapper } from './Navigation.styles';

const Navigation = () => {
  const [activeIndex, setActiveIndex] = useState<number | undefined>(undefined);
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { allPlayersData } = useContext(PlayersContext);
  const canSeeSelect =
    allPlayersData?.[0]?.status !== 'UPCOMING' &&
    allPlayersData?.[0]?.selection?.length !== 0;

  const SideBarNavigations: Omit<SidebarButtonProps, 'isActive'>[] = [
    {
      label: t('home'),
      icon: {
        Component: <Home />,
      },
      link: paths.home,
      onLinkClick: () => {
        triggerGTAGInternalNavEvent('https://atpgamezone.com/home');
        navigate(paths.home);
      },
      onTabClick: () => setActiveIndex(activeIndex),
    },
    {
      label: 'Play',
      icon: {
        Component: <Game />,
      },
      link: paths.wins,
      onLinkClick: () => {
        triggerGTAGInternalNavEvent('https://atpgamezone.com/wins');
        navigate(
          allPlayersData?.[0]?.status === 'UPCOMING'
            ? paths.wins
            : canSeeSelect
              ? paths.shutout
              : paths.home,
        );
      },
      onTabClick: () => setActiveIndex(activeIndex),
    },
    {
      label: 'Leaderboards',
      icon: {
        Component: <Leaderboard />,
      },
      link: pathname === paths.weekly ? paths.weekly : paths.monthly,
      onLinkClick: () => {
        triggerGTAGInternalNavEvent('https://atpgamezone.com/monthly');
        navigate(paths.monthly);
      },
      onTabClick: () => setActiveIndex(activeIndex),
    },
    {
      label: 'Schedule',
      icon: {
        Component: <Helmet />,
      },
      link: paths.rankings,
      onLinkClick: () => {
        triggerGTAGInternalNavEvent('https://atpgamezone.com/ranking');
        navigate(paths.rankings);
      },
      onTabClick: () => setActiveIndex(activeIndex),
      // redirectLink:
      //   'https://www.nhl.com/news/nhl-fantasy-hockey-goalie-challenge-game-projected-starters-picks/c-340353950?tid=277729150',
    },

    {
      label: 'Help',
      AdditionalComponent: <HelpComponents />,
      icon: {
        Component: <HowToPlay />,
      },
      onTabClick: () => setActiveIndex(activeIndex),
    },
    // {
    //   label: t('offRuls'),
    //   icon: {
    //     Component: <OfficialRules />,
    //   },
    //   link: paths.rules,
    //   onLinkClick: () => navigate(paths.rules),
    //   onTabClick: () => setActiveIndex(activeIndex),
    // },
    // {
    //   label: 'ATP Social',
    //   AdditionalComponent: <SocialLink />,
    //   icon: {
    //     Component: <Social />,
    //   },
    //   onTabClick: () => setActiveIndex(activeIndex),
    // },
    // {
    //   label: 'Top 5 Rankings',
    //   icon: {
    //     Component: <Helmet />,
    //   },
    //   link: paths.rankings,
    //   onLinkClick: () => navigate(paths.rankings),
    //   onTabClick: () => setActiveIndex(activeIndex),
    //   // redirectLink:
    //   //   'https://www.nhl.com/news/nhl-fantasy-hockey-goalie-challenge-game-projected-starters-picks/c-340353950?tid=277729150',
    // },
  ];

  useEffect(() => {
    if (activeIndex && activeIndex !== 3 && activeIndex !== 4) {
      setActiveIndex(undefined);
    }
  }, [activeIndex]);

  return (
    <NavigationWrapper>
      {SideBarNavigations.map((item, index) => {
        const isButtonDisabledOnPreview =
          index !== SideBarNavigations.length - 1 &&
          window.location.pathname === 'paths.preview';
        return (
          <SidebarButton
            AdditionalComponent={item.AdditionalComponent}
            icon={item.icon}
            isActive={
              (activeIndex ? index === activeIndex : pathname === item.link) ||
              (item.label === 'Leaderboards' &&
                pathname.includes(paths.leaderboardScores))
            }
            key={index}
            label={item.label}
            onLinkClick={
              isButtonDisabledOnPreview ? undefined : item.onLinkClick
            }
            onTabClick={() =>
              !isButtonDisabledOnPreview
                ? setActiveIndex(index === activeIndex ? undefined : index)
                : undefined
            }
            redirectLink={item.redirectLink}
          />
        );
      })}
    </NavigationWrapper>
  );
};

export default Navigation;
